import React from 'react';
import { TextField } from 'rmwc/TextField';

export const MTextField = (props) => {
  return (
    <TextField
      id={props.id}
      className={props.className}
      label={props.label}
      value={props.value}
      onChange={props.onChange}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/MTextField.js